// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login-m__wrapper__2rj28","actions-wrapper":"login-m__actions-wrapper__2f84k","link-button":"login-m__link-button__n4DUq"};